import React from 'react';

const ProofOfIncomeTab = () => {
  return (
    <div>
      
    </div>
  );
};

ProofOfIncomeTab.propTypes = {};

export default ProofOfIncomeTab;
